import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "😍", key: "triedAndLovedIt" },
  { emoji: "😬", key: "triedAndRegretted" },
  { emoji: "🌟", key: "wantToTry" },
  { emoji: "😰", key: "scaredToTry" },
]

export default function HomeDecisionMomentPage() {
  return (
    <RadioCardListPage translationKey="homeDecisionMoment" options={OPTIONS} />
  )
}
